import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import PropTypes from 'prop-types';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
import { Link } from 'react-router-dom';
import { TOP_LEVEL_ROUTES } from '../../../scripts/routes';

const truncateText = (text, maxLength) =>
	text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;

const JONPageCard = ({ ClinicalPageData }) => {
	const {
		imageUrl,
		displayName,
		page: { pageId },
	} = ClinicalPageData;

	return (
		<Card>
			<CardActionArea
				component={Link}
				to={`/${TOP_LEVEL_ROUTES.joinOurNetwork}/${pageId}`}
			>
				<CardMedia
					image={imageUrl}
					title={displayName}
					sx={{ height: 181 }}
				/>
				<CardContent sx={{ height: 126 }}>
					<Typography
						component='h3'
						variant='h5'
						sx={{
							overflow: 'hidden',
							width: '100%',
							height: '100%',
						}}
					>
						{truncateText(displayName, 65)}
					</Typography>
				</CardContent>
			</CardActionArea>
		</Card>
	);
};

JONPageCard.propTypes = {
	ClinicalPageData: PropTypes.object.isRequired,
};

export default JONPageCard;
